import { Box, keyframes, Typography } from '@mui/material';
import React from 'react';

const RollingSoon = () => {

  return (
    <Box sx={{display:"flex",alignItems:"center",justifyContent:"center",padding:"2px",borderRadius:"3px",backgroundColor: "#ffd700",width:"100px"}}>
        <Typography sx={{color: "black",fontSize:"10px"}}>Rolling out soon</Typography> 
    </Box>
  );
};

export default RollingSoon;